import styled from 'styled-components';

const CHILD_LIST_VERTICAL_OFFSET = 33;

export const LinkChildList = styled.ul`
  display: flex;
  position: absolute;
  left: 0;
  top: ${CHILD_LIST_VERTICAL_OFFSET}px;
  width: auto;
  margin: 0;
  padding: 0;

  opacity: 0;
  visibility: hidden;

  transform: translate(5px, 0);
  transition: visibility 0s linear 300ms, opacity 300ms, transform 400ms;
`;

export const LinkList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: inline-flex;
  flex-wrap: wrap;

  li {
    display: block;
    position: relative;
    white-space: nowrap;
    user-select: none;
  }

  li:not(:first-child) {
    margin-left: 0px;
  }

  li > a,
  li > span {
    display: block;
    padding: 8px 10px;
  }

  li.parent:hover {
    > span {
      color: #888;
      cursor: default;
    }

    > ${LinkChildList} {
      opacity: 1;
      visibility: visible;

      transform: translate(0, 0);
      transition: visibility 0s linear 0s, opacity 300ms, transform 400ms;
    }
  }
`;
